import { useParams } from "react-router-dom";
import useTranslator from "../../hooks/useTranslator";
import { useContext, useState } from "react";
import AuthContext from "../../context/auth/AuthContext";
import LandLordContext from "../../context/landlord/LandLordContext";
import { toast } from "../../helper/common";
import { Avatar, Button, Modal } from "../design";

const ConfirmMemberRemovalModal = ({ onClose, llData, refreshFunc }) => {
  const { _t } = useTranslator();
  const { workspaceId } = useParams();
  const { user } = useContext(AuthContext);
  const { deleteWorkspaceMember } = useContext(LandLordContext);

  const [buttonDisable, setButtonDisable] = useState(false);

  const memberName = `${llData?.landlordId?.fname_companyName ?? ""} ${
    llData?.landlordId?.lname ?? ""
  }`.trim();
  const workspaceName =
    user?.workspaceIds?.find(
      (val) => val?.uuid?.toString() === workspaceId?.toString()
    )?.name ?? "";

  const handleSubmitButton = () => {
    setButtonDisable(true);
    deleteWorkspaceMember({ user_id: llData?.landlordId?._id })
      .then(() => {
        toast.success(_t("memberRemovedSuccessfully"));
        refreshFunc();
        onClose();
      })
      .catch((err) => {
        console.log(err);
        toast.error(_t("errorWhileRemovingMember"));
      })
      .finally(() => {
        setButtonDisable(false);
      });
  };

  return (
    <Modal
      open
      onClose={onClose}
      size="sm"
      title={`${_t("confirmMemberRemovalFromWorkspace")} ${workspaceName}`}
      description={_t(
        "areYouSureYouWantToRemoveThisMemberFromThisYourWorkspaces"
      )}
      actions={
        <>
          <Button
            variant="secondary"
            size="lg"
            onClick={onClose}
            disabled={buttonDisable}
          >
            {_t("noGoBack")}
          </Button>
          <Button
            variant="danger"
            size="lg"
            onClick={handleSubmitButton}
            loading={buttonDisable}
          >
            {_t("yesRemove")}
          </Button>
        </>
      }
    >
      <div className="workspace-confirm-person">
        <Avatar name={memberName} size="sm" />
        <span>{memberName}</span>
      </div>
    </Modal>
  );
};

export default ConfirmMemberRemovalModal;
